import { useContext, useEffect } from 'react'
import { pageView } from 'utils/Analytics'
import { AppContext } from '../contexts/AppContext'

/**
 * Just add this hook to your component and page view tracking
 * will be called on mount
 * @param {string} pageName
 * @param {string} path - The current page path
 */
const useAnalyticsPageTracker = (pageName, path) => {
  const { domain } = useContext(AppContext)
  useEffect(() => {
    if (domain && pageName && path) {
      pageView(domain, pageName)
    }
  }, [domain, pageName, path])
}

export default useAnalyticsPageTracker
